import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import AMap from 'vue-amap';
import store from './store'
import global from '@/utils/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import Validate from '@/utils/filter_rules'
import permission from './directive'
import '@/icons'

import VueCropper from 'vue-cropper';
Vue.use(VueCropper);
// 签名
import vueEsign from 'vue-esign';
Vue.use(vueEsign);

// import '@/assets/css/variates.scss';
import '@/assets/css/public.scss';

import { hasPermission } from '@/permission/index.js'
Vue.prototype.perms = hasPermission;
Vue.prototype.size = 'mini';
import util from '@/utils/util';
Vue.prototype.util = util;
Vue.prototype.$$util = util;
Vue.prototype.$$utils = util;
import setting from './setting';
Vue.prototype.$$setting = setting;

import { parseTime, selectDictLabels, selectDictLabel } from "@/utils/osUtil";
Vue.use(Validate)
Vue.use(AMap)  // AMap
Vue.use(ElementUI)  // 注册使用Element
Vue.use(api)  // 注册使用API模块
Vue.use(permission)

Vue.prototype.global = global // 挂载全局配置模块
Vue.prototype.parseTime = parseTime
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.selectDictLabel = selectDictLabel
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: 'fae06d72afb349d4750189be5587d345',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.Geolocation',
    'AMap.Geocoder',
    'AMap.AMapManager',
    'AMap.Marker',
    'AMap.PolyEditor'],
  v: '1.4.4',
  uiVersion: '1.1'

});

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js